import { render } from "./UsageStatusSectionSeikyuCmp.vue?vue&type=template&id=0c80964a&scoped=true"
import script from "./UsageStatusSectionSeikyuCmp.vue?vue&type=script&lang=js"
export * from "./UsageStatusSectionSeikyuCmp.vue?vue&type=script&lang=js"

import "../css/UsageStatusSectionSeikyu.css?vue&type=style&index=0&id=0c80964a&scoped=true&lang=css"
import "./UsageStatusSectionSeikyuCmp.vue?vue&type=style&index=1&id=0c80964a&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src991838332/src/git-codecommit.ap-northeast-1.amazonaws.com/v1/repos/splats-mypage-dev/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0c80964a"]])

export default __exports__